<template>
    <div class="mini-wishlist">
        <a :href="url" data-newwindow class="wishlist-link mini-link">
            <i class="demo-icon icon-group-5584"></i>
            <span v-if="countFavoriteItems" class="count">{{countFavoriteItems}}</span>
        </a>

        <div class="tooltip">
            {{favoriteTitle}}
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    /**
     * Компонент для отображения количества избранных товаров в шапке сайта
     *
     * @vuedoc
     * @module vue:components/MiniFavorite
     * @exports vue:components/MiniFavorite
     */

    export default {
        name: "mini-top-favorite",

        components: {
        },

        props: [
            'title', 'url'
        ],
        /**
         * Данные экземпляра компонента
         *
         * @method data
         * @property {string} favoriteTitle - Значение в тултипе в зависемости от языка на сайте
         */
        data() {
            return {
                favoriteTitle: this.title,
            }
        },

        computed: {
            ...mapGetters('favorite', [
                'favoriteItems',
            ]),

            /**
             *  Вычисляемое свойство которое получает список товаров в избранных
             *
             * @method getFavoriteItems
             */
            getFavoriteItems() {
                if(typeof this.favoriteItems !== 'undefined') {
                    return this.favoriteItems;
                }
            },

            /**
             *  Вычисляемое свойство которое определяет количество товаров в избранных
             *
             * @method countFavoriteItems
             */
            countFavoriteItems() {
                return _.keys(this.favoriteItems).length;
            },
        },

        mounted(){
        },

        methods: {
        }
    }


</script>
